import {FC, useEffect} from 'react'
import {fetchData} from '../../reusable'
import {
  LANG_SYNCED_KEY,
  SUPPORTED_LANGS,
  getSelectedLang,
  isUserSelectedLang,
  saveLanguage,
  syncLanguageToProfile,
} from './Metronici18n'

/**
 * Keeps the UI language and the vendor profile in sync, once per session.
 *
 * - The user picked a language on this browser -> that choice is preserved and pushed
 *   to the profile (`public/changelanguage`).
 * - No explicit choice yet -> the profile language (`public/viewProfile`) becomes the default.
 *
 * The login flow already handles both cases, this covers sessions that are restored
 * without going through the login screen.
 */
const LanguageInit: FC = () => {
  useEffect(() => {
    const initLanguage = async () => {
      if (sessionStorage.getItem(LANG_SYNCED_KEY)) {
        return
      }

      const vendor = sessionStorage.getItem('vendor')
      if (!vendor) {
        return
      }

      let vendorId
      try {
        vendorId = JSON.parse(vendor)?.vendorId
      } catch (er) {
        console.error(er)
        return
      }
      if (!vendorId) {
        return
      }

      // the local selection wins - store it on the profile instead of reading it back
      if (isUserSelectedLang()) {
        if (await syncLanguageToProfile(getSelectedLang())) {
          sessionStorage.setItem(LANG_SYNCED_KEY, '1')
        }
        return
      }

      try {
        const response: any = await fetchData('public/viewProfile', {vendorId})
        if (response?.status != '200' || !response?.data?.length) {
          return
        }

        const profileLang = response.data[0]?.language
        sessionStorage.setItem(LANG_SYNCED_KEY, '1')

        if (!profileLang || !SUPPORTED_LANGS.includes(profileLang)) {
          // the profile has no language yet - seed it with the current one
          await syncLanguageToProfile(getSelectedLang())
          return
        }

        if (saveLanguage(profileLang)) {
          window.location.reload()
        }
      } catch (er) {
        console.error(er)
      }
    }

    initLanguage()
  }, [])

  return null
}

export {LanguageInit}
